<template>
  <h2
    :class="[
      'articles__headline',
      {
        'articles__headline--festival': isFestivalYear,
      },
    ]"
    :style="{
      backgroundImage: isFestivalYear ? 'none' : `url(${listPageBanner})`,
    }"
  >
    {{ listTitle }}
  </h2>
</template>

<script>
import artworkBanner from '@/assets/images/banner/artwork_banner.png';
import templeBanner from '@/assets/images/banner/temple_banner.png';
import albumBanner from '@/assets/images/banner/album_banner.png';
import tourBanner from '@/assets/images/banner/tour_banner.png';
import tagBanner from '@/assets/images/banner/tag_banner.png';
import searchBanner from '@/assets/images/banner/search_banner.png';
import favouriteBanner from '@/assets/images/banner/favourite_banner.png';
import featureBanner from '@/assets/images/banner/feature_banner.png';

export default {
  name: 'TheListTitle',
  props: {
    listTitle: {
      type: String,
      default: '文章列表',
    },
    prefix: {
      type: String,
      default: 'artwork',
    },
  },
  data() {
    return {};
  },
  computed: {
    isFestivalYear() {
      return this.$route.meta.isRenderingFestivalTheme;
    },
    listPageBanner() {
      switch (this.prefix) {
        case 'artwork': {
          return artworkBanner;
        }

        case 'temple': {
          return templeBanner;
        }

        case 'album': {
          return albumBanner;
        }

        case 'tour': {
          return tourBanner;
        }

        case 'tag': {
          return tagBanner;
        }

        case 'search': {
          return searchBanner;
        }

        case 'favourite': {
          return favouriteBanner;
        }

        case 'feature': {
          return featureBanner;
        }

        default:
          return artworkBanner;
      }
    },
  },
  methods: {},
  components: {},
};
</script>

<style lang="scss" scoped>
.articles {
  &__headline {
    position: relative;
    background-position: center;
    background-size: cover;
    font-size: 0;
    text-align: center;
    height: 160px;

    @include for-tablet-horizontal {
      height: 200px;
    }

    &--festival {
      font-family: $text-font-family;
      font-size: 1.5rem;
      color: $color-light-text;
      background: none;
      // padding: 30px 0;
      padding: 45px 5% 25px;
      margin: 0;
      letter-spacing: 1.71px;
      height: auto;

      @include for-desktop {
        letter-spacing: 2px;
      }

      &::before,
      &::after {
        background: none;
      }
    }
  }
}
</style>
